// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Delivery.module.scss  */
.Delivery-module-Root_swx {
  display: flex;
  align-items: center; }

.Delivery-module-Text_2nF {
  font-family: var(--control-font-family);
  font-size: 0.75rem;
  line-height: 1.25;
  color: var(--delivery-color-default); }

.Delivery-module-notAvailableVariant_3fK .Delivery-module-Text_2nF {
  color: var(--delivery-color-attention); }

.Delivery-module-pickupVariant_hp9 .Delivery-module-Text_2nF {
  color: var(--delivery-color-warning); }

.Delivery-module-prescriptionOnlyVariant_33d .Delivery-module-Text_2nF {
  color: var(--delivery-color-attention); }

.Delivery-module-quickVariant_2wU .Delivery-module-Icon_1_r {
  fill: var(--delivery-color-icon); }

.Delivery-module-quickVariant_2wU .Delivery-module-Text_2nF {
  padding-left: 7px; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Delivery/Delivery.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB,EAAE;;AAEvB;EACE,uCAAuC;EACvC,kBAAkB;EAClB,iBAAiB;EACjB,oCAAoC,EAAE;;AAExC;EACE,sCAAsC,EAAE;;AAE1C;EACE,oCAAoC,EAAE;;AAExC;EACE,sCAAsC,EAAE;;AAE1C;EACE,gCAAgC,EAAE;;AAEpC;EACE,iBAAiB,EAAE","sourcesContent":["/*  imported from Delivery.module.scss  */\n.Delivery-module-Root_swx {\n  display: flex;\n  align-items: center; }\n\n.Delivery-module-Text_2nF {\n  font-family: var(--control-font-family);\n  font-size: 0.75rem;\n  line-height: 1.25;\n  color: var(--delivery-color-default); }\n\n.Delivery-module-notAvailableVariant_3fK .Delivery-module-Text_2nF {\n  color: var(--delivery-color-attention); }\n\n.Delivery-module-pickupVariant_hp9 .Delivery-module-Text_2nF {\n  color: var(--delivery-color-warning); }\n\n.Delivery-module-prescriptionOnlyVariant_33d .Delivery-module-Text_2nF {\n  color: var(--delivery-color-attention); }\n\n.Delivery-module-quickVariant_2wU .Delivery-module-Icon_1_r {\n  fill: var(--delivery-color-icon); }\n\n.Delivery-module-quickVariant_2wU .Delivery-module-Text_2nF {\n  padding-left: 7px; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
